module.exports = __webpack_public_path__ + "img/BookmarkedIconFilled.467dd62b.svg";